module.exports = __webpack_public_path__ + "media/maps-markers/green-pin-bacf4bd1.svg";